export const createFileNode = (fileType) => ({ result, file }) => {
    var _a, _b;
    return fileType.create({
        href: result.url,
        download: (_a = result.name) !== null && _a !== void 0 ? _a : file.name,
        type: (_b = result.type) !== null && _b !== void 0 ? _b : file.type,
    });
};
